// src/features/services/components/ServiceTimeline.tsx

const PLACEHOLDER_STAGES = ['رویداد اخیر', 'رویداد پیشین', 'رویداد قدیمی‌تر'];

/**
 * Activity timeline — presentation-only visual shape, no real event
 * data source exists yet. Stage labels are generic placeholders and do
 * not claim or imply any actual service history.
 */
export function ServiceTimeline() {
  return (
    <ol className="flex flex-col">
      {PLACEHOLDER_STAGES.map((stage, index) => (
        <li key={stage} className="flex gap-3">
          <div className="flex flex-col items-center">
            <span
              className="mt-1 h-2 w-2 shrink-0 rounded-full border border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] bg-transparent"
              aria-hidden="true"
            />
            {index < PLACEHOLDER_STAGES.length - 1 && (
              <span
                className="w-px flex-1 bg-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]"
                aria-hidden="true"
              />
            )}
          </div>

          <div className="min-w-0 flex-1 pb-3">
            <p className="text-xs font-medium text-[var(--vania-colors-text-secondary,#a3aab8)]">{stage}</p>
            <p className="mt-0.5 text-[11px] text-[var(--vania-colors-text-secondary,#a3aab8)]">
              پس از یکپارچه‌سازی با منبع رویدادها در دسترس خواهد بود.
            </p>
          </div>
        </li>
      ))}
    </ol>
  );
}
